export { default as getStaticPropsFactory } from './lib/getStaticProps';
export { default as LandingPage } from './lib/landing-pages';
export { RemortgageBannerCombination as InstantValMyHomeBanner } from './lib/components/remortgage';
